import React from 'react'
import ReactDOM from 'react-dom'
import Main from './main_container.js'
import { BrowserRouter, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/root_reducer'
import { waitForRoot } from '../../common/wait_for_root.js'

let store = createStore(
  rootReducer,
  applyMiddleware(
    thunk
  )
)

waitForRoot(root => {
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <Route path='/:locale?/listings/:room_group_id' component={Main}/>
      </Provider>
    </BrowserRouter>,
    root
  )
})
